import { Component } from 'react'
import { AutoAffix } from 'react-overlays'
import ShareButtons from '../../../shared/share-buttons/share-buttons'
import RenderOnScroll from 'shared/render-on-scroll'

export default class PostSocialButton extends Component {
  render() {
    let { container, ...props } = this.props

    return (
      <RenderOnScroll
        triggerY={25}
        containerRef={container}
        offsetClasses={['navbar-default', 'navbar-secondary']}
      >
        <AutoAffix
          viewportOffsetTop={60}
          container={container}
          affixClassName="affixed"
          bottomClassName="bottom"
          className="bas"
        >
          <div className="fadeIn posts-sidebar-wrapper">
            <div className="pan prxl mtn">
              <ShareButtons
                className="hidden-xs text-right article-side-share pln"
                shareText="Share"
                {...props}
              />
            </div>
          </div>
        </AutoAffix>
      </RenderOnScroll>
    )
  }
}
